import type { CmmdBoardTask } from "@cmmd-forge/contracts";

export interface SubtaskProgress {
  readonly done: number;
  readonly total: number;
}

/**
 * Completed/total subtask progress when child rows are present on the board
 * payload. Falls back to null when only `childCount` exists (no per-child
 * status), so callers can show a quiet count instead of inventing completion.
 */
export function deriveSubtaskProgress(task: CmmdBoardTask): SubtaskProgress | null {
  if (task.childCount <= 0) return null;
  if (task.children.length === 0) return null;
  const done = task.children.filter((child) => child.status === "done").length;
  return { done, total: task.childCount };
}
